export default __webpack_public_path__ + "static/media/AppIcon.9c84b10a.jpg";